// Shared cross-asset "cross-read" logic used by the sidebar cards AND the alert
// engine so the two never drift. A lean is { dir: "up"|"down"|"neutral", label, idx? }.

// Spec positioning lean from the Williams COT Index (percentile of net-noncomm long).
export function cotIndexLean(m) {
  if (!m || m.cot_index_1y == null) return { dir: "neutral", label: "Neutral", idx: null };
  const idx = Math.round(m.cot_index_1y);
  if (idx >= 55) return { dir: "up", label: "Bullish", idx };
  if (idx <= 45) return { dir: "down", label: "Bearish", idx };
  return { dir: "neutral", label: "Neutral", idx };
}

export function usdLean(b) {
  if (b?.bias === "bullish") return { dir: "up", label: "Bullish" };
  if (b?.bias === "bearish") return { dir: "down", label: "Bearish" };
  return { dir: "neutral", label: "Neutral" };
}

export function riskLean(rt) {
  const score = rt?.score;
  if (score == null) return { dir: "neutral", label: "Neutral" };
  if (score > 0) return { dir: "up", label: "Risk-On" };
  if (score < 0) return { dir: "down", label: rt.tone === "risk-off" ? "Risk-Off" : "Cautious" };
  return { dir: "neutral", label: "Neutral" };
}

// Gold spec positioning vs USD news bias — the two normally move INVERSELY,
// so pointing the SAME way is the conflict.
export function goldUsdCrossRead(gold, usdBias) {
  const g = cotIndexLean(gold);
  const u = usdLean(usdBias);
  let status = "neutral";
  if (g.dir !== "neutral" && u.dir !== "neutral") status = g.dir === u.dir ? "conflict" : "aligned";
  const note =
    status === "conflict"
      ? `Gold spec positioning is ${g.label.toLowerCase()} while the USD read is ${u.label.toLowerCase()} — but gold and the dollar usually move inversely. Something has to give; treat both directional calls with caution.`
      : status === "aligned"
      ? `Gold positioning (${g.label.toLowerCase()}) and the USD read (${u.label.toLowerCase()}) fit their usual inverse relationship — the cross-asset story is coherent.`
      : `No clear conflict — ${g.dir === "neutral" ? "gold positioning" : "the USD bias"} is currently neutral, so the inverse read is inconclusive.`;
  return { status, gold: g, usd: u, note };
}

// WTI spec positioning vs macro risk tone — crude TRACKS risk appetite,
// so pointing OPPOSITE ways is the conflict.
export function oilRiskCrossRead(wti, riskTone) {
  const o = cotIndexLean(wti);
  const r = riskLean(riskTone);
  let status = "neutral";
  if (o.dir !== "neutral" && r.dir !== "neutral") status = o.dir === r.dir ? "aligned" : "conflict";
  const note =
    status === "conflict"
      ? `WTI positioning is ${o.label.toLowerCase()} while the macro risk tone is ${r.label.toLowerCase()} — but crude usually tracks risk appetite. Spec oil and the risk regime are pulling apart; one is likely to correct.`
      : status === "aligned"
      ? `WTI positioning (${o.label.toLowerCase()}) matches the ${r.label.toLowerCase()} risk tone — crude and risk appetite are in sync.`
      : `No clear conflict — ${o.dir === "neutral" ? "WTI positioning" : "the risk tone"} is currently neutral, so the read is inconclusive.`;
  return { status, oil: o, risk: r, note };
}
